import React from 'react';

import styled from '@emotion/styled';

import { useMediaQuery } from '@zego/hooks/useMediaQuery';
import { unit } from '@zego/theme';
import useTracking from '@zego/tracking/useTracking';

import ButtonLink from '@zego/components/button/ButtonLink';

const PartnerWithUsButton = styled(ButtonLink)({
  width: '100%',
  height: unit(8),
  whiteSpace: 'nowrap',
});

interface GetAQuoteProps {
  salesforceCampaignId?: string;
}

/**
 * @param rest - these props are for the button
 */
export default function FleetBrokerPartnerWithUsButton({
  salesforceCampaignId,
  ...rest
}: GetAQuoteProps): JSX.Element {
  const { trackEvent } = useTracking();

  const isMobile = useMediaQuery('(max-width: 600px)');
  const buttonText = isMobile ? 'Join our network' : 'Join our Broker network';

  return (
    <PartnerWithUsButton
      href="/broker/partner-with-us/"
      onClick={(): void => {
        trackEvent(
          'Broker Landing Page, Join broker network - Sticky Banner Button Clicked',
        );
      }}
      {...rest}
    >
      {buttonText}
    </PartnerWithUsButton>
  );
}
